export default "<p>\n  details works!\n</p>\n"